import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

/** Hide vendor path segments such as /brightdata/ from merchant-facing URLs. */
export function publicDisplayUrl(url) {
  return String(url || "").replace(/\/brightdata(?=\/|$)/gi, "")
}